import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

const InvoicePreview = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const invoiceUrl = location.state?.invoiceUrl;

  useEffect(() => {
    if (!invoiceUrl) {
      navigate('/');  
    }
  }, [invoiceUrl, navigate]);

  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <div style={{ padding: '5px', borderBottom: '1px solid #ddd', background: '#fff' }}>
        <a href="#" onClick={() => navigate(-1)} style={{ cursor: 'pointer' }}>
          ←  
        </a> 
      </div>
      <iframe
        src={invoiceUrl}
        title="Invoice"
        style={{ flexGrow: 1, border: 'none', width: '100%' }}
      />
    </div>
  );
};

export default InvoicePreview;
